import * as React from "react"

function UbicacionIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.25 14.8" {...props}>
      <g data-name="Capa 2">
        <path
          d="M7 5.62a1.41 1.41 0 11-1.41-1.4A1.41 1.41 0 017 5.62m1.41 0a2.82 2.82 0 10-2.79 2.82 2.81 2.81 0 002.82-2.82m1.4-.46a9.53 9.53 0 01-1.52 4.31 30.11 30.11 0 01-2.7 3.84 31.2 31.2 0 01-2.69-3.84 9.53 9.53 0 01-1.52-4.31 4 4 0 014.21-3.75 4 4 0 014.22 3.75m1.41 0A5.41 5.41 0 005.62 0 5.41 5.41 0 000 5.16c0 3.11 3 7.2 4.64 9.16a1.25 1.25 0 002 0c1.61-2 4.64-6.05 4.64-9.16"
          fill="#003da6"
          data-name="Capa 1"
        />
      </g>
    </svg>
  )
}

export default UbicacionIcon
